import * as React from 'react';

import Box from '@mui/material/Box';
// import Icon from '/public/assets/Group 3900.svg';
import Icon1 from '../../assets/FMA-Icons_Chart.png';
import Icon2 from '../../assets/FMA-Icons_Soar.png';
import Icon3 from '../../assets/FMA-Icons_Success.png';

export default function Program(){
    return (
        <Box className='wrapper store'>
            <h2 className='section-title'>Set Sail For Excellence</h2>
            {/* <p className='subtitle'>An exciting and impactful journey awaits you:</p> */}
            <Box className='content'>
                <Box className='item'>
                    <span className='icon' style={{ backgroundImage: `url(${Icon1})`}}></span>
                    <Box className='detail'>
                        <h4 className='title'>Chart Your Course and Broaden Your Horizons</h4>
                        <p className='desc'>
                        Connect the dots as you experience different facets of Sea's businesses in Digital Entertainment, E-commerce and Digital Payment and Financial Services.
                        </p>
                    </Box>
                </Box>
                <Box className='item'>
                    <span className='icon' style={{ backgroundImage: `url(${Icon3})`}}></span>
                    <Box className='detail'>
                        <h4 className='title'>Ride the Waves of Success With Inspiring Leaders</h4>
                        <p className='desc'>
                            Interact with seasoned finance professionals, leveraging on their guidance and feedback as you take ownership of your growth and navigate challenges throughout the program. 
                        </p>
                    </Box>
                </Box>
                <Box className='item'>
                    <span className='icon' style={{ backgroundImage: `url(${Icon2})`}}></span>
                    <Box className='detail'>
                        <h4 className='title'>Dive Deep into Accounting and Technology, Soar to New Heights</h4>
                        <p className='desc'>
                            Hone your technical skills and business acumen through hands-on application and expand your perspectives through involvement in local and regional projects.
                        </p>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
